import * as React from 'react';
import devNote from '@xingternal/dev-note';
import { TextButton } from '..';
import * as Styled from './button.styles';
export const Button = (allProps) => {
    const { children, className, disabled = false, ellipsis, href, icon: Icon, innerRef, loading, onClick, size = 'medium', sizeConfined, sizeWide, to, type, variant, ...props } = allProps;
    const iconSize = size === 'small' ? 18 : 24;
    const iconOnly = !children;
    const commonProps = {
        $ellipsis: ellipsis,
        $iconOnly: iconOnly,
        $size: size,
        $sizeConfined: sizeConfined,
        $sizeWide: sizeWide,
        $variant: variant,
        'aria-label': loading ? 'loading' : null,
        'data-xds': 'Button',
        className,
        disabled: disabled || loading,
        onClick,
        ref: innerRef,
    };
    // @ts-ignore
    if (variant === 'text') {
        devNote.deprecate(`The variant "text" of the Button component was removed, TextButton should be used instead.`);
        // @ts-ignore (fabSize is not implemented in the TextButton)
        return React.createElement(TextButton, { type: type, ...allProps });
    }
    const buttonContent = (React.createElement(Styled.InnerContent, { "$ellipsis": ellipsis },
        !loading && Icon && (React.createElement(Styled.IconContainer, { "$iconSize": iconSize },
            React.createElement(Icon, { width: iconSize, height: iconSize }))),
        loading && (React.createElement(Styled.Loading, { "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, "aria-hidden": "true" })),
        React.createElement(Styled.Text, { "$ellipsis": ellipsis, "$loading": loading }, children)));
    return (React.createElement(React.Fragment, null, to || href ? (React.createElement(Styled.RouterButton, { ...(to && { to }), ...(href && { href }), ...commonProps, ...props }, buttonContent)) : (React.createElement(Styled.Button, { type: type, ...commonProps, ...props }, buttonContent))));
};
Button.displayName = 'Button';
//# sourceMappingURL=button.js.map